import { inject, Injectable } from '@angular/core'
import { catchError, map, Observable, tap, throwError } from 'rxjs'
import { PostTradingEventInterface } from '@modules/options-module/post-trading/interfaces/post-trading-event.interface'
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http'
import { EnvironmentsHelperService } from '@environments/core/services/environments-helper.service'
import { PostTradingEventQueryParamsInterface } from '@modules/options-module/post-trading/interfaces/post-trading-event-query-params.interface'
import { TranslateService } from '@ngx-translate/core'
import { AlertService } from '@shared/services/alert.service'
import { PostTradingHelperService } from '@modules/options-module/post-trading/services/post-trading-helper.service'

@Injectable({
	providedIn: 'root',
})
export class PostTradingService {
	protected readonly string: StringConstructor = String
	protected readonly object: ObjectConstructor = Object

	private readonly _http: HttpClient = inject<HttpClient>(HttpClient)
	private readonly _environmentsHelperService: EnvironmentsHelperService =
		inject<EnvironmentsHelperService>(EnvironmentsHelperService)
	private readonly _postTradingHelperService: PostTradingHelperService =
		inject<PostTradingHelperService>(PostTradingHelperService)
	private readonly _alertService: AlertService = inject<AlertService>(AlertService)
	private readonly _translateService: TranslateService = inject<TranslateService>(TranslateService)

	public getPostTradingEvents(
		postTradingEventsParams: PostTradingEventQueryParamsInterface,
	): Observable<PostTradingEventInterface[]> {
		let params: HttpParams = new HttpParams()

		this.object.entries(postTradingEventsParams).forEach(([key, value]: [string, unknown]): void => {
			params = params.append(key, this.string(value))
		})

		this._postTradingHelperService.setLoadingByState(postTradingEventsParams.entry_type, true)

		return this._http
			.get<
				PostTradingEventInterface[]
			>(`${this._environmentsHelperService.apiUrl}/options/v1/options_events/`, { params })
			.pipe(
				map((response: PostTradingEventInterface[]): PostTradingEventInterface[] => {
					return this._postTradingHelperService.filterPostTradingEvents(
						response,
						postTradingEventsParams.date_from,
						postTradingEventsParams.date_to,
					)
				}),
				tap((response: PostTradingEventInterface[]): void => {
					this._postTradingHelperService.setPostTradingEventsByType(
						response,
						postTradingEventsParams.entry_type,
					)
					this._postTradingHelperService.setLoadingByState(postTradingEventsParams.entry_type, false)
				}),
				catchError((error: HttpErrorResponse): Observable<never> => {
					this._postTradingHelperService.setLoadingByState(postTradingEventsParams.entry_type, false)
					this._alertService.error(
						error.error.error.message ??
							this._translateService.instant('postTrading.errors.postTradingEvents'),
					)
					return throwError(
						(): Observable<never> =>
							error.error.error.message ??
							this._translateService.instant('postTrading.errors.postTradingEvents'),
					)
				}),
			)
	}
}
